export var supportedLanguages = ['ja'];
